import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

console.log(" React app starting...");

// Set global status
window.reactAppStatus = "starting";

window.addEventListener("beforeunload", () => {
  // localStorage.clear();
});


try {
  const rootElement = document.getElementById("root");

  if (!rootElement) {
    throw new Error("Root element not found");
  }

  console.log(" Root element found, creating React root...");

  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  window.reactAppStatus = "rendered";
  console.log(" React app rendered successfully");

  reportWebVitals();
} catch (error) {
  console.error(" Failed to render React app:", error);
  window.reactAppStatus = "error: " + error.message;

  // Show error on screen
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: Arial, sans-serif; background: #ffebee; color: #c62828;">
      <h1>React App Error</h1>
      <p><strong>Error:</strong> ${error.message}</p>
      <p>Check the developer console for details.</p>
    </div>
  `;
}
